import type { GetterTree } from 'vuex'
import type { RootState } from 'store'
import type { DivisionState } from './types'

export const getters: GetterTree<DivisionState, RootState> = {
  divisions: (state: DivisionState) => state.divisions,
  total: (state: DivisionState) => state.divisions && state.divisions.length,
  regions: (state: DivisionState) => state.regions,
  selectCompany: (state: DivisionState) => state.selectCompany,
  selectedDivision: (state: DivisionState) => state.selectedDivision,
}
